import React, { useEffect, useState, useCallback } from "react";

// Bootstrap imports
import {
  Row,
  Col,
  ButtonGroup,
} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs"; 
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import * as Icon from "react-bootstrap-icons";

// highchart imports
import * as Highcharts from "highcharts/highstock";
import drilldown from "highcharts/modules/drilldown";
import HighchartsReact from "highcharts-react-official";
import * as HighchartsExporting from "highcharts/modules/exporting";

// external libraries
import Select from "react-select";

import { getFromLS } from "../../../utils/storage";
import { ThreeCircles } from "react-loader-spinner";
import { logout } from "../../../utils";
import { NoAccessPopup } from "../../../reusable-components/NoAccessPopupComponent/NoAccessModal";
import { TemplateDownloadRenderer } from "../TemplateDownloadRenderer";
import DropFileInput from "../../../reusable-components/DropFileComponent/DropFileComponent";
import OffCanvasNavbar from '../reportNavbar'
import { ReportGrid } from "../ReportGrid";
import { TemplateDescriptionPopover } from "../TemplatePopoverlay";

require("highcharts/modules/accessibility")(Highcharts);
Highcharts.seriesType("column2", "column", {});
// Highcharts text formatter
Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});

drilldown(Highcharts);
HighchartsExporting(Highcharts);

// Report renderer
const BillableReport = () => {
  const featureName = "Capacity vs Billable & Non-billable  Report";
  const accessibleFeatures = getFromLS("active-features");

  // Check for access else return no access modal
  const [noAccessModalShow, setNoAccessModalShow] = useState(false);
  // if (!accessibleFeatures.includes(featureName)) {
  //   return <NoAccessPopup featurename={featureName} />;
  // }


  // declare default grid params
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);

  // set or declare default report variables
  const [firm_id, setFirmId] = useState(getFromLS("firmId"));
  // This report is specifically only for XCM
  const [vendor, setVendor] = useState("xcm");

  const [reportDate, setReportDate] = useState();
  const [hoursRemaining, setHoursRemaining] = useState();
  const [activeStaff, setActiveStaff] = useState();
  const [titleChart1, setTitleChart1] = useState(
    "Average billable hours by month per user"
  );
  const [titleChart2, setTitleChart2] = useState(
    "Total billable hours by month"
  );
  const [categories, setCategories] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  const [columnChartData1, setColumnChartData1] = useState([]);
  const [columnChartData2, setColumnChartData2] = useState([]);
  const localChartTheme = getFromLS("chart-theme");
  const [compareChartDataTotal, setCompareChartDataTotal] = useState();
  const [compareChartDataAvg, setCompareChartDataAvg] = useState();
  const [originalChartDataTotal, setOriginalChartDataTotal] = useState();
  const [originalChartDataAvg, setOriginalChartDataAvg] = useState();
  const [compareToggle, setCompareToggle] = useState(false);

  const [optionsData, setOptionsData] = useState([
    { id: "month", Name: "Month" },
  ]);
  let sortOptionsData = [
    { id: "staff", Name: "Ascending by staff name" },
    { id: "billable", Name: "Ascending by billable hours" },
  ];
  const [sortSelect, setSortSelect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderText, setLoaderText] = useState(false);
  // set default API params
  const [reportApiResponse, setReportApiResponse] = useState({
    data: { 0: { report: { staff: [] } } },
  });
  // set local mode params
  const [localApiResponse, setLocalApiResponse] = useState({
    data: { 0: { report: { staff: [] } } },
  });
  const [template_file_list, setTemplateFileList] = useState([]);
  const [templateDescription, setTemplateDescription] = useState("")
  const [localMode, setLocalMode] = useState(false);
  const [localLoaderToggle, setLocalLoaderToggle] = useState(true);


  /**
   * In this functionm, we pass the API response to extract template links to be displayed in local mode.
   * @param {*} result: API response.
   * @returns API response (for further use).
   */
  const setTemplateFiles = (result) => {
    const templates = result.data[0].report.templates
    setTemplateFileList(templates)
    const templateDescriptionHolder = []
    for(let template in templates){
      Object.assign(templateDescriptionHolder, {[templates[template].name + templates[template].extension]: templates[template].description})
    }
    setTemplateDescription(templateDescriptionHolder)
    return result
  }

  /**
   * This function enables the local mode and maintains the state of loaders and messages to be displayed.
   */
  const LocalModeEnabler = () => {
    setLocalLoaderToggle(true);
    if (localMode) {
      console.log("LOCAL MODE API RESPONSE: ", localApiResponse)
      setLoaderText(true);
      setApiData(reportApiResponse, false);
      setLocalLoaderToggle(false);
    }
    setLocalMode(!localMode);
  };

  const filesMap = {
    "TemplateProductionAndBilling": "",
    "TemplateStarStaff": ""
  }

  /**
   * This function accepts the uploaded template excel files and adds them to the payload for making Local Mode API call
   * @param {*} files 
   * @param {*} filename 
   */
  const onFileChange = (files, filename) => {
    console.log("FILENAME: ", filename)
    console.log("FILES: ", files)
    const formData = new FormData();
    if (filename == "TemplateProductionAndBilling") {
      filesMap.TemplateProductionAndBilling = files[0]
    } else if (filename == "TemplateStarStaff") {
      filesMap.TemplateStarStaff = files[0]
    }
    console.log("FILES: ", filesMap)
    if (filesMap.TemplateProductionAndBilling != "" && filesMap.TemplateStarStaff != "") {
      formData.append("file1", filesMap.TemplateProductionAndBilling);
      formData.append("file2", filesMap.TemplateStarStaff);
      LocalModeApi(formData)
    } else {
      console.log("Both files hould be uploaded for making local mode api call.")
    }
  };

  /**
   * This function takes the payload of uploaded excel files and makes the Local Mode API call
   * @param {*} formData: Payload.
   */
  const LocalModeApi = (formData) => {
    // updating payload for Local Mode API
    formData.append("report_name", "billable");
    // This times out the loader till charts are generated
    if (formData) {
      setLoaderText(!loaderText);
      setTimeout(() => {
        setLocalLoaderToggle(false);
      }, 3000);
    }
    // call api and get data
    const requestOptions = {
      method: "POST",
      body: formData,
    };
    console.log("REQUEST OPTIONS:", requestOptions);
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/local/get_reports/`,
      requestOptions
    )
      // API data recieved
      .then((result) => result.json())
      // Local Mode API data state maintained
      .then((result) => {
        console.log("LOCAL MODE API: ", result)
        if (result.status === 200) {
          setLoaderText(!loaderText);
          setApiData(result, true)
          setTimeout(() => {
            setLocalLoaderToggle(false);
          }, 3000);
        } else {
          console.log("FAILED TO LOAD A LOCAL FILE!")
          setLocalLoaderToggle(true);
        }
      }
      ).catch(error => {
        console.error('ERROR IN LOCAL MODE API:', error);
      })
  }

  // maitain api response
  const setApiData = (result, localMode = false) => {
    console.log("API DATA: ", result)
    if (localMode) {
      setLocalApiResponse(result);
      setMeanColumnChartData(result, "month")
    } else {
      setReportApiResponse(result);
      setMeanColumnChartData(result, "month")
    }
    gridParamsMapper(result)
    return result;
  };

  /**
  * This function is used for formatting the default column names of the grid
  * @param {*} defaultName: Current name from API
  * @returns: Final column name
  */
  const GridColumnTitleRenderer = (defaultName) => {
    const splitWords = defaultName.split("_")
    for (let word in splitWords) {
      splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
    }
    return splitWords.join(" ")
  }

  /**
   * This function takes the API response data and maps it to the grid params
   * @param {*} result: API response
   */
  const gridParamsMapper = (result) => {
    console.log("GRID PARAM MAPPER RESULT:", result)
    if (result.data[0].report.report.length != 0) {
      const keys = Object.keys(result.data[0].report.report[0]) // You need to change this based on API response format in every report
      let jsonColDefs = keys.map(key => {
        return {
          field: key, headerName: GridColumnTitleRenderer(key)
        }
      });
      setColDefs(jsonColDefs)
    }
    setRowData(result.data[0].report.report);
  }


  useEffect(() => {
    setIsLoading(true);

    // fetch data from billable Report API
    const getRequestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/billable/`,
      getRequestOptions
    )
      // API data recieved
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })

      .then((result) => setSelectOptions(result));
  }, []);

  /**
   * This function creates the options for filter dropdown select required in this report.
   * @param {*} reportData: Report data from API.
   */
  const setSelectOptions = (reportData) => {
    let optionsDataHolder = [];
    for (let obj in reportData) {
      if (obj == "data") {
        const value = reportData[obj][0]["pivot_by"];
        for (let optobj in value) {
          let val = value[optobj];
          let optionObject = {
            id: val.name,
            Name: val.display_name,
          };
          optionsDataHolder.push(optionObject);
        }
      }
      setOptionsData(optionsDataHolder);
    }
  };

  let setMeanColumnChartData = (result, selectedOpt, sortby = undefined) => {
    var opt = "";
    if (selectedOpt) {
      opt = "x_label";
    }
    var table_data = result.data[0].report.report;
    if (sortby != undefined) {
      if (sortby == "billable") {
        table_data = table_data.sort((a, b) =>
          a.avg_billable_current_year > b.avg_billable_current_year ? -1 : 1
        );
      } else if (sortby == "staff") {
        table_data = table_data.sort((a, b) => (a.staff > b.staff ? 1 : -1));
      }
    } else {
      table_data = result.data[0].report.report;
    }

    const cats = [];
    const capacity = [];
    const py_capacity = [];
    const unused_capacity = [];
    const py_unused_capacity = [];
    const avg_billable = [];
    const avg_non_billable = [];
    const total_billable = [];
    const total_non_billable = [];
    const py_avg_non_billable = [];
    const py_total_non_billable = [];
    const py_avg_billable = [];
    const py_total_billable = [];
    setTitleChart1("Average billable hours by " + selectedOption.Name);
    for (let key in table_data) {
      const val = table_data[key];
      cats.push(val[opt]);
      unused_capacity.push(
        val.average_capacity_current_year -
        val.avg_billable_current_year -
        val.avg_non_billable_current_year
      );
      py_unused_capacity.push(
        val.average_capacity_previous_year -
        val.avg_billable_previous_year -
        val.avg_non_billable_previous_year
      );
      if (val.average_capacity_current_year != undefined) {
        capacity.push(val.average_capacity_current_year);
      } else {
        capacity.push(0);
      }
      if (val.average_capacity_previous_year != undefined) {
        py_capacity.push(val.average_capacity_previous_year);
      } else {
        py_capacity.push(0);
      }
      if (val.avg_billable_current_year != undefined) {
        avg_billable.push(val.avg_billable_current_year);
      } else {
        avg_billable.push(0);
      }
      if (val.avg_non_billable_current_year != undefined) {
        avg_non_billable.push(val.avg_non_billable_current_year);
      } else {
        avg_non_billable.push(0);
      }
      if (val.total_billable_current_year != undefined) {
        total_billable.push(val.total_billable_current_year);
      } else {
        total_billable.push(0);
      }
      if (val.total_non_billable_current_year != undefined) {
        total_non_billable.push(val.total_non_billable_current_year);
      } else {
        total_non_billable.push(0);
      }
      if (val.avg_non_billable_previous_year != undefined) {
        py_avg_non_billable.push(val.avg_non_billable_previous_year);
      } else {
        py_avg_non_billable.push(0);
      }
      if (val.total_non_billable_previous_year != undefined) {
        py_total_non_billable.push(val.total_non_billable_previous_year);
      } else {
        py_total_non_billable.push(0);
      }
      if (val.avg_billable_previous_year != undefined) {
        py_avg_billable.push(val.avg_billable_previous_year);
      } else {
        py_avg_billable.push(0);
      }
      if (val.total_billable_previous_year != undefined) {
        py_total_billable.push(val.total_billable_previous_year);
      } else {
        py_total_billable.push(0);
      }
    }
    setCategories(cats);
    const data = [
      {
        name: "Capacity",
        data: capacity,
        stack: "capacity",
        type: "spline",
        marker: {
          radius: 8,
        },
        zIndex: 1,
      },
      {
        name: "Non-Billable",
        data: avg_non_billable,
        stack: "actual",
        type: "column",
      },
      {
        name: "Billable",
        data: avg_billable,
        stack: "actual",
        type: "column",
      },
      {
        name: "Unused Capacity",
        data: unused_capacity,
        stack: "actual",
        type: "spline",
        marker: {
          radius: 8,
        },
        zIndex: 1,
      },
    ];

    const data2 = [
      {
        name: "Capacity",
        data: capacity,
        stack: "capacity",
        type: "spline",
        marker: {
          radius: 8,
        },
        zIndex: 1,
      },
      {
        name: "Non-Billable",
        data: avg_non_billable,
        stack: "actual",
        type: "column",
      },
      {
        name: "Billable",
        data: avg_billable,
        stack: "actual",
        type: "column",
      },
      {
        name: "Unused Capacity",
        data: unused_capacity,
        stack: "actual",
        type: "spline",
        marker: {
          radius: 8,
        },
        zIndex: 1,
      },
      {
        name: "Previous Year Non-Billable",
        data: py_avg_non_billable,
        stack: "py_actual",
        type: "column",
      },
      {
        name: "Previous Year Billable",
        data: py_avg_billable,
        stack: "py_actual",
        type: "column",
      },
      {
        name: "Previous Year Unused Capacity",
        data: py_unused_capacity,
        stack: "py_actual",
        type: "spline",
        marker: {
          radius: 8,
        },
        zIndex: 1,
      },
    ];
    setSumColumnChartData(result, (sortby = sortby));
    setColumnChartData1(data);
    setOriginalChartDataAvg(data);
    setCompareChartDataAvg(data2);
    const hoursRemaining = result.data[0].report.hours_remain_in_busy_season;
    const reportDate = result.data[0].report.most_recent_report_date;
    const active_staff = result.data[0].report.current_active_employees;
    setReportDate(reportDate);
    setHoursRemaining(hoursRemaining);
    setActiveStaff(active_staff);
    setRowData(result.data[0].report.data);
    return result.data[0].report.data;
  };

  let setSumColumnChartData = (result, sortby = undefined) => {
    var table_data = result.data[0].report.report;
    if (sortby != undefined) {
      if (sortby == "billable") {
        table_data = table_data.sort((a, b) =>
          a.total_billable_current_year > b.total_billable_current_year ? -1 : 1
        );
      } else if (sortby == "staff") {
        table_data = table_data.sort((a, b) => (a.staff > b.staff ? 1 : -1));
      }
    } else {
      table_data = result.data[0].report.report;
    }
    const capacity = [];
    const py_capacity = [];
    const unused_capacity = [];
    const py_unused_capacity = [];
    const avg_billable = [];
    const avg_non_billable = [];
    const total_billable = [];
    const total_non_billable = [];
    const py_total_non_billable = [];
    const py_avg_non_billable = [];
    const py_avg_billable = [];
    const py_total_billable = [];
    setTitleChart2("Total billable hours by " + selectedOption.Name);
    for (let key in table_data) {
      const val = table_data[key];
      unused_capacity.push(
        val.total_billable_current_year +
        val.total_non_billable_current_year -
        val.capacity_current_year
      );
      py_unused_capacity.push(
        val.capacity_previous_year -
        val.total_billable_previous_year -
        val.total_non_billable_previous_year
      );
      if (val.capacity_current_year != undefined) {
        capacity.push(val.capacity_current_year);
      } else {
        capacity.push(0);
      }
      if (val.capacity_previous_year != undefined) {
        py_capacity.push(val.capacity_previous_year);
      } else {
        py_capacity.push(0);
      }
      if (val.avg_billable_current_year != undefined) {
        avg_billable.push(val.avg_billable_current_year);
      } else {
        avg_billable.push(0);
      }
      if (val.avg_non_billable_current_year != undefined) {
        avg_non_billable.push(val.avg_non_billable_current_year);
      } else {
        avg_non_billable.push(0);
      }
      if (val.total_billable_current_year != undefined) {
        total_billable.push(val.total_billable_current_year);
      } else {
        total_billable.push(0);
      }
      if (val.total_non_billable_current_year != undefined) {
        total_non_billable.push(val.total_non_billable_current_year);
      } else {
        total_non_billable.push(0);
      }
      if (val.avg_non_billable_previous_year != undefined) {
        py_avg_non_billable.push(val.avg_non_billable_previous_year);
      } else {
        py_avg_non_billable.push(0);
      }
      if (val.total_non_billable_previous_year != undefined) {
        py_total_non_billable.push(val.total_non_billable_previous_year);
      } else {
        py_total_non_billable.push(0);
      }
      if (val.avg_billable_previous_year != undefined) {
        py_avg_billable.push(val.avg_billable_previous_year);
      } else {
        py_avg_billable.push(0);
      }
      if (val.total_billable_previous_year != undefined) {
        py_total_billable.push(val.total_billable_previous_year);
      } else {
        py_total_billable.push(0);
      }
    }

    const data = [
      {
        name: "Capacity",
        data: capacity,
        stack: "capacity",
        type: "spline",
        marker: {
          radius: 8,
        },
        zIndex: 1,
      },
      {
        name: "Non-Billable",
        data: total_non_billable,
        stack: "actual",
        type: "column",
      },
      {
        name: "Billable",
        data: total_billable,
        stack: "actual",
        type: "column",
      },
    ];

    const data2 = [
      {
        name: "Capacity",
        data: capacity,
        stack: "capacity",
        type: "spline",
        marker: {
          radius: 8,
        },
        zIndex: 1,
      },
      {
        name: "Non-Billable",
        data: total_non_billable,
        stack: "actual",
        type: "column",
      },
      {
        name: "Billable",
        data: total_billable,
        stack: "actual",
        type: "column",
      },
      {
        name: "Previous Year Non-Billable",
        data: py_total_non_billable,
        stack: "py_actual",
        type: "column",
      },
      {
        name: "Previous Year Billable",
        data: py_avg_billable,
        stack: "py_actual",
        type: "column",
      },
    ];
    setColumnChartData2(data);
    setOriginalChartDataTotal(data);
    setCompareChartDataTotal(data2);
    setIsLoading(false);
  };

  const options = optionsData.map((item) => ({
    value: item.id,
    label: item.Name,
  }));

  const sortOptions = sortOptionsData.map((item) => ({
    value: item.id,
    label: item.Name,
  }));
  let selectedOption = optionsData[0];

  const handleSelect = (selected) => {
    setIsLoading(true);
    let value = selected.value;
    if (compareToggle) {
      setCompareToggle(!compareToggle);
    }
    if (value == "staff") {
      setSortSelect(true);
    }
    filterBillableData(value);
  };

  const handleSort = (selected) => {
    setIsLoading(true);
    let sortby = undefined;
    for (let opt in sortOptionsData) {
      if (sortOptionsData[opt].id == selected.value) {
        sortby = sortOptionsData[opt].id;
      }
    }
    setMeanColumnChartData(reportApiResponse, pivot_by, (sortby = sortby));
  };

  const filterBillableData = (value) => {
    for (let opt in defaultOptions) {
      if (defaultOptions[opt].id == value) {
        selectedOption = defaultOptions[opt];
      }
    }
    const pivot_by = value;
    const pivotRequestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ firm_id, vendor, pivot_by }),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/billable/`,
      pivotRequestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((result) => setMeanColumnChartData(result, pivot_by))
      .then((rowData) => setRowData(rowData));
  };

  const pivot_by = selectedOption.id;
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ firm_id, vendor, pivot_by }),
  };

  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api;
    gridApi.closeToolPanel();
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/billable/`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((result) => setApiData(result))
      // Maintaining the templatye files sent from API response
      .then((result) => (setTemplateFiles(result)))
  }, []);

  // grid export functionality
  const onBtExcelExport = useCallback(() => {
    gridApi.exportDataAsExcel();
  }, []);

  const onBtCSVExport = useCallback(() => {
    gridApi.exportDataAsCsv();
  }, []);

  // interactive primary chart
  const primaryOptions = {
    chart: {
      type: "column",
      height: 600,
    },
    title: {
      align: "center",
      text: titleChart1,
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    colors: localChartTheme.colors,
    xAxis: {
      categories: categories,
      min: 0,
      max: 5,
      offset: 25,
      tickWidth: 2,
      tickLength: 10,
    },
    scrollbar: {
      enabled: true,
    },

    yAxis: {
      title: {
        text: "Hours",
      },
    },

    plotOptions: {
      column: {
        groupPadding: 0.1,
        pointPadding: 0.1,
        stacking: "normal",
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span> <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },

    series: columnChartData1,
  };

  const secondaryOptions = {
    chart: {
      type: "column",
      height: 600,
      // width: 1400
      marginRight: 25,
    },
    title: {
      align: "center",
      text: titleChart2,
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    colors: localChartTheme.colors,
    xAxis: {
      categories: categories,
      min: 0,
      max: 5,
      offset: 25,
      tickWidth: 2,
      tickLength: 10,
    },
    scrollbar: {
      enabled: true,
    },

    yAxis: {
      title: {
        text: "Hours",
      },
    },

    plotOptions: {
      column: {
        groupPadding: 0.1,
        pointPadding: 0.1,
        stacking: "normal",
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span><b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },

    series: columnChartData2,
  };

  let handleCompare = (e) => {
    setCompareToggle(!compareToggle);
    if (compareToggle) {
      e.preventDefault();
      setColumnChartData1(originalChartDataAvg);
      setColumnChartData2(originalChartDataTotal);
    } else {
      e.preventDefault();
      setColumnChartData1(compareChartDataAvg);
      setColumnChartData2(compareChartDataTotal);
    }
  };

  const Switch = ({ isToggled, onClick }) => {
    return (
      <label className="switch">
        <input type="checkbox" checked={isToggled} onChange={onClick} />
        <span className="slider round"></span>
      </label>
    );
  };

  const defaultOptions = [
    { id: "month", Name: "Month" },
    { id: "staff", Name: "Staff Member" },
    { id: "role", Name: "Role Type" },
  ];

  const loader =
    hoursRemaining != [] &&
    activeStaff != [] &&
    rowData != [] &&
    categories != [];


  useEffect(() => {
    if (loader) {
      setIsLoading(false);
      setTimeout(() => {
        setLocalLoaderToggle(false);
        setLoaderText(true);
      }, 2000);
    }
  }, [loader]);

  const ScreenLoader = () => {
    return (
      <div>
        <div className="spinner">
          <ThreeCircles
            height="100"
            width="100"
            color=""
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="three-circles-rotating"
            outerCircleColor="var(--theme1_primary)"
            innerCircleColor="var(--theme1_secondary)"
            middleCircleColor="var(--theme1_tertiary)"
          />
          <h5
            style={{
              position: "relative",
              left: "-35%",
              padding: "10px",
            }}
          >
            Loading your details of billable and non-billable hours
          </h5>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="row-wrapper">
        <div className="row-container">
          {localMode ? (
            <>
              <h3 className="intelligence-report-name">{featureName}</h3>
              <Row className="local-import-row">
                <Col md={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <p style={{ color: "#000", fontWeight: "900", marginBottom: 10, marginRight: 20 }}> Download templates
                    <TemplateDescriptionPopover 
                      description={templateDescription}
                    />
                  </p>
                  <Row className="no-gutter">
                    {
                      template_file_list && template_file_list.map((object, index) => (
                        <TemplateDownloadRenderer info={object} key={index} />
                      )
                      )
                    }
                  </Row>
                </Col>
                {
                  template_file_list && template_file_list.map((object, index) => (
                    object.send_back
                      ?
                      <Col md={5} key={index}>
                        <DropFileInput onFileChange={(files) => onFileChange(files, object.name)} message={`Drag and drop ${object.name + "." + object.extension} file here`} />
                      </Col>
                      :
                      <></>
                  )
                  )
                }
              </Row>
            </>
          ) : (
            <>
              <h3 className="intelligence-report-name">{featureName}</h3>
              <Row className="report-card-row">
                <div className="report-card">
                  <div className="chip-header">Number of active staff</div>
                  <div className="chip-body">{activeStaff}</div>
                </div>
                <div className="report-card">
                  <div className="chip-header">Report date</div>
                  <div className="chip-body">{reportDate}</div>
                </div>
              </Row>
            </>
          )
          }
        </div>
      </div>

      <div className="row-wrapper">
        <div className="row-container">
          <Tabs
            defaultActiveKey="chart"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="chart" title="Chart" className="tabs">
              <OffCanvasNavbar
                localtoggle={
                  <ButtonGroup>
                    <div className="toggler">
                      {localMode ? (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Go back online
                        </p>
                      ) : (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Switch to local mode
                        </p>
                      )}
                    </div>
                    <div className="toggler">
                      <Switch
                        isToggled={localMode}
                        onClick={() => LocalModeEnabler()}
                      ></Switch>
                    </div>
                  </ButtonGroup>
                }
                secondtoggle={
                  <ButtonGroup>
                    <div className="toggler">
                      <p style={{ color: "#000" }}>
                        Compare with previous year
                      </p>
                    </div>
                    <div className="toggler">
                      <Switch
                        isToggled={compareToggle}
                        onClick={handleCompare}
                      ></Switch>
                    </div>
                  </ButtonGroup>
                }
                selectfirst={
                  sortSelect ? (
                    <Select
                      options={sortOptions}
                      aria-label="Sort"
                      closeMenuOnSelect={true}
                      placeholder="Sort by"
                      defaultValue={"Sort by"}
                      menuPosition="fixed"
                      // className="sort-select"
                      onChange={(e) => handleSort(e)}
                    />
                  ) : (
                    <div></div>
                  )}
                selectsecond={
                  <Select
                    options={options}
                    aria-label="Default"
                    closeMenuOnSelect={true}
                    defaultValue={options[0]}
                    menuPosition="fixed"
                    // className="billable-select"
                    onChange={(e) => handleSelect(e)}
                  />
                }
              />

              <Row>
                <Col md="6">
                  {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                    <div className="chart-container">
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={secondaryOptions}
                      />
                    </div>
                  )}
                </Col>
                <Col md="6">
                  {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                    <div className="chart-container">
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={primaryOptions}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="grid" title="Grid" className="tabs">
              <DropdownButton
                as={ButtonGroup}
                className="reset-button download-excel"
                title=" Export"
                id="bg-nested-dropdown"
                drop="start"
              >
                <Dropdown.Item onClick={onBtExcelExport}>
                  {" "}
                  <Icon.FileExcel /> Excel Export
                </Dropdown.Item>
                <Dropdown.Item onClick={onBtCSVExport}>
                  {" "}
                  <Icon.FiletypeCsv /> CSV Export
                </Dropdown.Item>
              </DropdownButton>
              <Row>
                <Col md="12" className="grid-row staffing">
                  <ReportGrid
                    rowData={rowData}
                    colDefs={colDefs}
                    onGridReady={onGridReady}
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default BillableReport;
